import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import { cn } from '@/utils/cn';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  leadingIcon?: ReactNode;
  trailingSlot?: ReactNode;
  invalid?: boolean;
  inputSize?: 'md' | 'lg';
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { leadingIcon, trailingSlot, invalid, inputSize = 'md', className, ...props },
  ref,
) {
  return (
    <div className="relative flex items-center">
      {leadingIcon ? (
        <span
          className="pointer-events-none absolute left-3 flex items-center text-subtle"
          aria-hidden="true"
        >
          {leadingIcon}
        </span>
      ) : null}
      <input
        ref={ref}
        aria-invalid={invalid || undefined}
        className={cn(
          'w-full rounded-md border bg-surface text-fg placeholder:text-subtle',
          'transition-colors focus:border-accent',
          'disabled:cursor-not-allowed disabled:opacity-60',
          inputSize === 'lg' ? 'h-12 text-base' : 'h-9 text-sm',
          leadingIcon ? 'pl-10' : 'pl-3',
          trailingSlot ? 'pr-24' : 'pr-3',
          invalid ? 'border-danger' : 'border-border',
          className,
        )}
        {...props}
      />
      {trailingSlot ? (
        <div className="absolute right-1.5 flex items-center">{trailingSlot}</div>
      ) : null}
    </div>
  );
});
